import { ensureNamespace } from '@/lib/i18n/runtime'
import { createFileRoute } from '@tanstack/react-router'
import { ContactsPage } from '@/features/contacts/components/ContactsPage'

export const Route = createFileRoute('/_auth/contacts')({
  beforeLoad: async () => { await Promise.all([ensureNamespace('contacts'), ensureNamespace('tags')]).catch(() => { /* Boundaries expose native retry. */ }) },
  validateSearch: (search: Record<string, unknown>): { contact?: string } => ({
    contact: typeof search.contact === 'string' ? search.contact : undefined,
  }),
  component: ContactsRoute,
})

// eslint-disable-next-line react-refresh/only-export-components
function ContactsRoute() {
  const { contact } = Route.useSearch()
  return <ContactsPage key={contact ?? 'none'} initialContactId={contact} />
}
